module.exports = __webpack_public_path__ + "static/media/400431_02.5e5904a8.png";